import Vue from 'vue';
import helper from './../../../shared/helper';
/* eslint-disable no-param-reassign */

const recruitmentModule = {
	actions: {
		async loadRecruitmentConfig({ commit }) {
			const RECRUITMENT_TOOL_CODE = 'RCM';
			const { data } = await Vue.prototype.$http.get(`/tools/${RECRUITMENT_TOOL_CODE}`);
			commit('UPDATE_MAIN_DATA', data);
		},
		async loadJobs({ commit }, items) {
			const params = {
				sortField: 'name',
				sortDirection: 'ASC',
				areaIds: items.selectedId,
				search: items.searchJob,
			};
			try {
				const { data: response } = await Vue.prototype.$httpPraktiko.get('groups/jobs', { params });
				commit('UPDATE_JOBS', response);
			} catch (error) {
				this.showGenericError();
			}
		},
		async loadGroups({ commit }) {
			const params = {
				sortField: 'name',
				sortDirection: 'ASC',
			};
			const { data: response } = await Vue.prototype.$httpPraktiko.get('groups', { params });
			commit('LOAD_GROUPS_DATA', response);
		},
		toggleJobSelection({ commit }, job) {
			helper.setLocalData('jobSelected', job);
			commit('UPDATE_SELECTED_JOBS', job);
		},
		clearSelectedJobs({ commit }) {
			helper.setLocalData('jobSelected', null);
			commit('CLEAR_SELECTED_JOBS');
		},
		saveIdConfigProcess({ commit }, id) {
			helper.setLocalData('idConfigProcess', id);
			commit('SAVE_ID_CONGIF_PROCESS', id);
		},
		async loadConfigProcess({ commit }, code) {
			const idConfigProcess = helper.getLocalData('idConfigProcess');
			try {
				if (idConfigProcess) {
					const { data: response } = await Vue.prototype.$httpPraktiko.get(`/recruitment/detail/${code}/${idConfigProcess}`);
					helper.setLocalData('dataConfigProcess', response);
					commit('UPDATE_DATA_CONFIG', response);
				} else {
					helper.setLocalData('dataConfigProcess', []);
					commit('UPDATE_DATA_CONFIG', []);
				}
			} catch (error) {
				console.error(error);
			}
		},
		dataProcessSelected({ commit }, data) {
			helper.setLocalData('dataProcessSelected', data);
			commit('DATA_PROCESS_SELECTED', data);
		},
		flagDisabledButton({ commit }, value) {
			commit('FLAG_EDIT_PROCESS', value);
		},
		async loadCivilStatus({ commit }) {
			const { data } = await Vue.prototype.$httpPraktiko.get('/general-data/ESCV');
			commit('UPDATE_LEVEL_SELECTION_CIVIL_STATUS', {
				name: 'Estado Civil',
				data,
			});
		},
		async loadTypeApplicants({ commit }) {
			const { data } = await Vue.prototype.$httpPraktiko.get('/general-data/TDPS');
			commit('UPDATE_LEVEL_SELECTION_TYPE_APPLICANT', {
				name: 'Tipo de Postulante',
				data,
			});
		},
		async loadTypeProcess({ commit }) {
			const { data } = await Vue.prototype.$httpPraktiko.get('/general-data/ESTPROCS');
			commit('UPDATE_LEVEL_SELECTION_TYPE_PROCESS', {
				name: 'Tipos de Procesos',
				data,
			});
		},
		dataInterview({ commit }, value) {
			helper.setLocalData('dataInterview', value);
			commit('SAVE_DATA_INTERVIEW', value);
		},
		applicantSelected({ commit }, value) {
			helper.setLocalData('applicantSelected', value);
			commit('SAVE_APPLICANT_SELECTED', value);
		},
	},
	state: {
		mainData: {},
		jobs: [],
		groups: [],
		idConfigProcess: null,
		recruitmentFlow: {
			selectedJobs: {},
			flagEditProcess: false,
			dataProcessSelected: [],
			dataInterview: [],
			applicantSelected: {},
		},
		dataConfigProcess: [],
		dataSelection: {
			civilStatus: [],
			typeApplicant: [],
			typeProcess: [],
		},
	},
	mutations: {
		UPDATE_MAIN_DATA(state, data) {
			state.mainData = data;
		},
		UPDATE_JOBS(state, payload) {
			state.jobs = payload;
		},
		LOAD_GROUPS_DATA(state, payload) {
			state.groups = payload;
		},
		UPDATE_SELECTED_JOBS(state, payload) {
			state.recruitmentFlow.selectedJobs = payload;
		},
		CLEAR_SELECTED_JOBS(state) {
			state.recruitmentFlow.selectedJobs = [];
		},
		SAVE_ID_CONGIF_PROCESS(state, payload) {
			state.idConfigProcess = payload;
		},
		UPDATE_DATA_CONFIG(state, payload) {
			state.dataConfigProcess = payload;
		},
		FLAG_EDIT_PROCESS(state, payload) {
			state.recruitmentFlow.flagEditProcess = payload;
		},
		DATA_PROCESS_SELECTED(state, payload) {
			state.recruitmentFlow.dataProcessSelected = payload;
		},
		UPDATE_LEVEL_SELECTION_CIVIL_STATUS(state, payload) {
			state.dataSelection.civilStatus = payload;
		},
		UPDATE_LEVEL_SELECTION_TYPE_APPLICANT(state, payload) {
			state.dataSelection.typeApplicant = payload;
		},
		UPDATE_LEVEL_SELECTION_TYPE_PROCESS(state, payload) {
			state.dataSelection.typeProcess = payload;
		},
		SAVE_DATA_INTERVIEW(state, payload) {
			state.recruitmentFlow.dataInterview = payload;
		},
		SAVE_APPLICANT_SELECTED(state, payload) {
			state.recruitmentFlow.applicantSelected = payload;
		},
	},
};

export default recruitmentModule;



// WEBPACK FOOTER //
// ./src/modules/recruitment/store/index.js